import { AffiliateRateCard } from './affiliate-rate-cards';

export { AffiliateRateCard };
